import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isHSDEnabled } from '../../config';
import { CreateCustomer, GetCustomer, ShippmentOrder } from '../../store/Checkout/actions';
import { customerGroup } from '../../store/PostActivation/actions';
import ButtonNew from '../Button/Button';
import './addLineSummary.scss';

type initialProps = {
    history: any;
    deviceDetails: any;
    setIsAddLineCharges: any;
    setIsLineAdded: any;
    setIsShipmentFailed: any;
    setIsAddLineSummary: any
    // ---- HSD Changes ------
    primaryHsdDiscount: number;
    secHsdDiscount: number;
    isHsdCustomer: boolean;
};

const AddLineSummary = (props: initialProps) => {
    const { deviceDetails, setIsAddLineCharges, setIsLineAdded, setIsShipmentFailed, setIsAddLineSummary,
        // ---- HSD Changes ------
        primaryHsdDiscount, secHsdDiscount, isHsdCustomer 
    } = props;

    const [customerDetails, setCustomerDetails] = useState<any>(null);
    const [currentPrice, setCurrentPrice] = useState<any>(null);
    const [newPrice, setNewPrice] = useState<any>(null);
    const [loader, setLoader] = useState(false);
    const [shippingRates, setShippingRates] = useState<any>(null);
    const [numOfLines, setNumOfLines] = useState<number>(0);
    const [isStandardAcc, setIsStandardAcc] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { checkout, activation } = useSelector((state: any) => state);

    useEffect(() => {
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        setCustomerDetails(customerDetails);
        if(customerDetails?.category === 'STANDARD') {
            setIsStandardAcc(true)
        }
        // const totalLines = customerDetails && customerDetails.totalActiveLines;
        let totalLines: any = localStorage.getItem('numOfLines');
        totalLines = JSON.parse(totalLines);
        setNumOfLines(totalLines);

        let currentPlan: any = null;
        currentPlan = localStorage.getItem('currentPlan');
        currentPlan = JSON.parse(currentPlan);
        if (currentPlan === null) {
            currentPlan = localStorage.getItem('reachSelectedPlanDetail');
            currentPlan = JSON.parse(currentPlan);
            currentPlan = currentPlan?.plan;
        }
        const currentPrice = handleChangePlanPrice(currentPlan, totalLines);
        const newPrice = handleChangePlanPrice(currentPlan, totalLines + 1);
        
        // ---- HSD Changes ------
        if(isHsdCustomer && isHSDEnabled) {
            if(totalLines === 1) {
                setCurrentPrice(currentPrice - primaryHsdDiscount);
                setNewPrice(newPrice - (primaryHsdDiscount + secHsdDiscount))
            } else if (totalLines > 1) {
                setCurrentPrice(currentPrice - (primaryHsdDiscount + secHsdDiscount * (totalLines - 1)))
                setNewPrice(newPrice - (primaryHsdDiscount + secHsdDiscount * (totalLines)))
            }
        } else {
            setCurrentPrice(currentPrice);
            setNewPrice(newPrice);
        }

        if (activation?.getAppData?.data && activation?.getAppData.status === 'SUCCESS') {
            const data = activation?.getAppData?.data?.shippingRates[0];
            setShippingRates(data);
        }
    }, []);

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current === true) {
            initialRender1.current = false;
        } else {
            const createCustomer = checkout.createCustomer;
            const errorCreateCustomer = checkout.errorCreateCustomer;
            if (createCustomer && createCustomer.status === 'SUCCESS' && createCustomer.data) {
                localStorage.setItem('secondaryCustomerDetail', JSON.stringify(createCustomer.data));
                executeShipmentOrder(createCustomer.data);
                if(!isStandardAcc) {
                    setLoader(false)
                    setIsLineAdded(true)
                }
            }
            if (errorCreateCustomer && errorCreateCustomer.status === 'FAILURE') {
                console.log('CREATE CUSTOMER FAILED');
                setLoader(false);
            }
        }
    }, [checkout.createCustomer, checkout.errorCreateCustomer]);

    const initialRender2 = useRef(true);
    useEffect(() => {
        if (initialRender2.current === true) {
            initialRender2.current = false;
        } else {
            const shippmentOrder = checkout.shippmentOrder;
            const errorShippmentOrder = checkout.errorShippmentOrder;
            if (shippmentOrder && shippmentOrder.status === 'SUCCESS' && shippmentOrder.data) {
                setIsLineAdded(true);
                setLoader(false);
                dispatch(customerGroup({ groupId: customerDetails && customerDetails.groupId }));
                dispatch(GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }));
            }
            if (errorShippmentOrder && errorShippmentOrder.status === 'FAILURE') {
                setLoader(false);
                setIsShipmentFailed(true);
                setIsAddLineSummary(false);
            }
        }
    }, [checkout.shippmentOrder, checkout.errorShippmentOrder]);

    const handleChangePlanPrice = (el: any, totalLines: any) => {
        let plan: any;
        let user: any = localStorage.getItem('customerDetail');
        user = JSON.parse(user);
        let currentPlan: any = localStorage.getItem('currentPlan');
        currentPlan = JSON.parse(currentPlan);

        if(user && user.reachPlanId === el.name ) {
            plan = currentPlan;
        } else {
            plan = el;
        }
        if (!plan.addLineSplitPrice) {
            return plan.baseLinePrice + totalLines * plan.additionalLinePrice;
        } else {
            const addLinePrice = plan.addLineSplitPrice;
            if (totalLines > 1) {
                let newPrice = 0;
                for (let i = 1; i <= totalLines - 1; i++) {
                    newPrice = newPrice + addLinePrice[i];
                }
                return plan.baseLinePrice + newPrice;
            } else {
                return plan.baseLinePrice;
            }
        }
    };

    const handleCreateCustomer = () => {
        if (deviceDetails?.esim) {
            setLoader(true);
            let accountRef = customerDetails.peerAccountRef.split('|');
            const numOfLine = (customerDetails && customerDetails.secondaryCustomers.length + 2).toString();
            const payload = {
                zipcode: customerDetails && customerDetails.zipcode ? customerDetails.zipcode : '01824',
                parentId: customerDetails && customerDetails.id,
                isMNP: false,
                isPrimary: false,
                primaryNumber: customerDetails && customerDetails.primaryNumber,
                addresses: customerDetails && customerDetails.addresses,
                status: 0,
                reachPlanId: customerDetails && customerDetails.reachPlanId,
                isSimInHand: false,
                extraLines: 0,
                selectedShippingMethod: customerDetails && customerDetails.selectedShippingMethod,
                esim: deviceDetails?.esim,
                imei: deviceDetails?.imei,
                make: deviceDetails?.make,
                model: deviceDetails?.model,
                activationJourneyStatus: 'NOT_STARTED',
                simPaid: true,
                peerAccountRef: `${accountRef[0]}|${accountRef[1]}|${numOfLine}`,
            };
            dispatch(
                CreateCustomer({
                    countryCode: 'USA',
                    data: payload,
                }),
            );
        } else {
            setIsAddLineCharges(true);
        }
    };

    const executeShipmentOrder = (secCustomer: any) => {
        const payload: any = {
            cId: customerDetails.id,
            reachCarrierId: shippingRates?.reachCarrierId,
            deliveryDays: shippingRates?.deliveryDays,
            serviceType: shippingRates?.serviceType,
            serviceCode: shippingRates?.serviceCode,
            carrierCode: shippingRates?.carrierCode,
            shipmentType: 'ESIM',
            category: 'SIM',
            shippingAmount: 0,
            taxAmount: 0,
            totalAmount: 0,
            secondaryCustomers: secCustomer?.id ? [secCustomer?.id] : [],
            orderType: 'NEW',
            shipTo: {
                city: customerDetails?.addresses[0]?.city,
                country: 'US',
                name: customerDetails?.addresses[0]?.name,
                phone: customerDetails?.addresses[0]?.phone,
                postalCode: customerDetails?.addresses[0]?.zip,
                residential: 'false',
                state: customerDetails?.addresses[0]?.state,
                street1: customerDetails?.addresses[0]?.address1,
                street2: customerDetails?.addresses[0]?.address2,
            },
            items: [
                {
                    quantity: 1,
                    unitPrice: 0,
                },
            ],
        };

        isStandardAcc &&
            dispatch(
                ShippmentOrder({
                    data: payload,
                }),
            );
    };

    return (
        <>
            <div className="AddLineSummaryCard">
                <div className="sub-heading">
                    <div className="addLineTitle">Changes to your monthly statement</div>
                    <div className="pricing">
                        <div className="current-pricing">
                            <div className="title">
                                Current pricing{' '}
                                {`(${numOfLines} ${
                                    numOfLines == 1 ? 'line' : 'lines'
                                })`}
                            </div>
                            <div className="pricingCont">
                                    <div className="data">{customerDetails && customerDetails.reachPlanId}</div>
                                    <div className="data-pricing">
                                        {`${currentPrice > 0 ? `$${(currentPrice)?.toFixed(2)}` : `$0.00`}`}
                                        {/* ${currentPrice?.toFixed(2)} */}
                                        <span>/mo.</span>
                                    </div>
                            </div>
                        </div>
                        <div className="hline"></div>
                        <div className="new-pricing">
                            <div className="title">
                                {' '}
                                New pricing {`(${numOfLines + 1} lines)`}
                            </div>
                            <div className="pricingCont">
                                    <div className="data">{customerDetails && customerDetails.reachPlanId}</div>
                                    <div className="data-pricing">
                                        {`${newPrice > 0 ? `$${(newPrice)?.toFixed(2)}` : `$0.00`}`}
                                        {/* ${newPrice?.toFixed(2)} */}
                                        <span>/mo.</span>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="confirm-btn">
                {
                    <ButtonNew primary={true} onClick={!loader ? handleCreateCustomer : ()=>{}}>
                        {loader ? (
                            <div className="loaderCheck text-center">
                                <CircularProgress />
                            </div>
                        ) : (
                            'CONFIRM'
                        )}
                    </ButtonNew>
                }
            </div>
        </>
    );
};

export default AddLineSummary;
